import { useState, useCallback } from 'react';

/**
 * useToast — a single transient toast with an optional action button (e.g. "Undo").
 *
 * const { toast, showToast, dismissToast } = useToast();
 * showToast('Deleted "Foo".', { actionLabel: 'Undo', onAction: () => restore(id) });
 * <Toast toast={toast} onDismiss={dismissToast} />
 */
export function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, action) => {
    setToast({ message, ...action });
  }, []);

  const dismissToast = useCallback(() => setToast(null), []);

  return { toast, showToast, dismissToast };
}
